import { AccountInfoParsedKycVerificationStatusEnum } from 'services/generatedClientFromSwagger';

export function isKycStatusComplete(status: AccountInfoParsedKycVerificationStatusEnum) {
    const completeStatuses = new Set([
        AccountInfoParsedKycVerificationStatusEnum.Approved,
        AccountInfoParsedKycVerificationStatusEnum.TraderAgreementAccepted,
    ]);

    return completeStatuses.has(status);
}

export function isKycStatusIncomplete(status: AccountInfoParsedKycVerificationStatusEnum) {
    return !isKycStatusComplete(status);
}
